import React, { useEffect, useState } from "react";
import { Button, Card, Col, Divider, Form, Input, Modal, Row, Tag, message } from "antd";
import { SearchOutlined, ArrowLeftOutlined, PlusOutlined, CloseOutlined } from "@ant-design/icons";
import ConfirmVote from "../../../../helpers/cards-helper/ConfirmVote";
import { ErrorCard } from "../../Patronage/PatronageReferred/voters-list/components/List";
import { useSelector } from "react-redux";
import ObserverService from "../../../../services/Election/ObserverService";
import ConfirmDelete from "../../../../helpers/cards-helper/ConfirmDelete";
import { filterDataByName, filterDataBySurname, isEmptyObject, setRowNumber } from "../../../../helpers/MainHelper";



const updateSearchFilters = (dispatch, requestFilters) => {
    const action = {
        type: "set_search_filters",
        payload: requestFilters
    };
    dispatch(action);
};


const filterItems = (items, filters) => {
    let filteredItems = items;

    if (filters?.name) {
        filteredItems = filterDataByName(filteredItems, filters.name);
    }

    if (filters?.surname) {
        filteredItems = filterDataBySurname(filteredItems, filters.surname);
    }

    if (filters?.listNumber) {
        filteredItems = filteredItems.filter((item) => item?.list_number === parseInt(filters.listNumber));
    }

    if ((filters?.name === null && filters?.surname === null) && (filters.listNumber === null || isNaN(filters.listNumber) === true)) {
        filteredItems = [];
    }

    return isEmptyObject(filters) ? [] : setRowNumber(filteredItems);
};


const rules = {
    name: [
        {
            required: true,
            min: 3,
            message: "Emri duhet të ketë minimalisht 3 karaktere!",
        },
    ],
};



const VotersList = ({ dispatch, qv, voters, allVoters, initialFilters, onBack }) => {
    const token = useSelector((state) => state.Member.token);
    const observer = useSelector((state) => state.Member.observer);
    const [dataSource, setDataSource] = useState(voters);
    const [form] = Form.useForm();
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [modalResetNumber, setModalResetNumber] = useState({ confirmModal: 0, deleteModal: 0 });


    useEffect(() => {
        let general = null;
        if (initialFilters?.name) {
            general = initialFilters?.name;
        }
        if (initialFilters?.surname) {
            general += " " + initialFilters?.surname;
        }

        form.setFieldsValue({
            general: general,
            listNumber: initialFilters?.listNumber
        })
    }, [form, initialFilters]);


    useEffect(() => {
        let filteredItems = voters;
        if (initialFilters) {
            filteredItems = filterItems(voters, initialFilters);
        }
        setDataSource(setRowNumber(filteredItems));
    }, [initialFilters, voters]);


    const onSearch = () => {
        setLoading(true);
        const { general, listNumber } = form.getFieldsValue(['general', 'listNumber']);
        const [name = null, surname = null] = general ? general.split(" ") : [];

        const requestFilters = {
            name: name || name !== "" ? name : null,
            surname: surname || surname !== "" ? surname : null,
            listNumber: listNumber !== null && listNumber !== undefined && listNumber !== "" ? parseInt(listNumber) : null,
        };

        updateSearchFilters(dispatch, requestFilters);
        setLoading(false);
    };


    const showConfirmModal = (item) => {
        setItem(item);
        setConfirmModal(true);
    };


    const closeConfirmModal = () => {
        setConfirmModal(false);
        setModalResetNumber({
            confirmModal: modalResetNumber.confirmModal + 1
        });
    };


    const showDeleteModal = (item) => {
        setItem(item);
        setDeleteModal(true);
    };


    const closeDeleteModal = () => {
        setDeleteModal(false);
        setModalResetNumber({
            deleteModal: modalResetNumber.deleteModal + 1
        });
    };


    const updateVoters = (allVoters, hasVoted, isSent) => {

        console.log('ITEM: ', item);

        const updatedVoters = allVoters?.map((voter) => {
            if (voter?.voter_id === item?.voter_id) {
                voter.voted = hasVoted;
                voter.isSent = isSent;
                return voter;
            }
            return voter;
        });

        console.log('UPDATED VOTERS: ', updatedVoters);

        const updatedQvVoters = voters?.map((voter) => {
            return {
                ...voter,
                voted: voter?.voter_id === item?.voter_id ? hasVoted : voter?.voted
            };
        });

        const action = {
            type: "set_all_voters",
            payload: updatedVoters
        };
        dispatch(action);

        const qvAction = {
            type: "set_qv_voters",
            payload: updatedQvVoters
        };
        dispatch(qvAction);
    };


    const onConfirm = () => {
        setLoading(true);
        const requestData = {
            observer_id: observer?.observer_id,
            voter_id: item?.voter_id
        };
        ObserverService.confirmVote(token, requestData)
            .then((response) => {
                updateVoters(allVoters, true, true);
                closeConfirmModal();
                setLoading(false);
            })
            .catch((err) => {
                updateVoters(allVoters, true, false);
                closeConfirmModal();
                setLoading(false);
            });
        message.success("Konfirmimi u krye me sukses!", 1);
    };


    const onDelete = () => {
        setLoading(true);
        const requestData = {
            voter_id: item?.voter_id
        };
        ObserverService.deleteVote(token, requestData)
            .then((response) => {
                updateVoters(allVoters, false, true);
                closeDeleteModal();
                setLoading(false);
            })
            .catch((err) => {
                updateVoters(allVoters, false, false);
                closeDeleteModal();
                setLoading(false);
            });
        message.success("Fshirja u krye me sukses!", 1);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card className="text-center" bodyStyle={{ padding: "15px" }}>
                            <Row gutter={24} align="middle">
                                <Col xl={5} lg={5} md={0} sm={0} xs={0} />
                                <Col xl={14} lg={14} md={0} sm={0} xs={0}>
                                    <h3 className="m-0 p-0">{qv?.code}</h3>
                                </Col>
                                <Col xl={5} lg={5} md={0} sm={0} xs={0} className="text-right">
                                    <Button
                                        type="secondary"
                                        onClick={onBack}
                                        style={{ height: "37px" }}
                                        icon={<ArrowLeftOutlined />}
                                    >
                                        Kthehu
                                    </Button>
                                </Col>
                            </Row>
                            <Row gutter={24} align="middle">
                                <Col xl={0} lg={0} md={4} sm={4} xs={4} />
                                <Col xl={0} lg={0} md={16} sm={16} xs={16}>
                                    <h4 className="m-0 p-0">{qv?.code}</h4>
                                </Col>
                                <Col xl={0} lg={0} md={3} sm={3} xs={3} className="text-right">
                                    <Button
                                        type="secondary"
                                        onClick={onBack}
                                        icon={<ArrowLeftOutlined />}
                                    />
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24} className="mt-2">
                    <Col span={24}>
                        <Form
                            form={form}
                        >
                            <Card bodyStyle={{ paddingBottom: "0" }}>
                                <Row gutter={24}>
                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                        <Form.Item name="general" rules={rules.name}>
                                            <Input
                                                allowClear
                                                type="text"
                                                placeholder="Kërko votues me emër & mbiemër..."
                                                prefix={<SearchOutlined />}
                                                min={1}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                        <Form.Item name="listNumber">
                                            <Input
                                                allowClear
                                                type="number"
                                                placeholder="Kërko votues me numër liste..."
                                                prefix={<SearchOutlined />}
                                                min={1}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xl={4} lg={4} md={24} sm={24} xs={24} className="text-right">
                                        <Form.Item>
                                            <Button
                                                block
                                                type="primary"
                                                onClick={onSearch}
                                                icon={<SearchOutlined />}
                                            >
                                                Kërko
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>
                        </Form>
                    </Col>
                </Row>

                {(dataSource?.length === 0 && isEmptyObject(initialFilters) === true) && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <Card>
                                <ErrorCard
                                    message={"Kërko votues me opsionet e mësipërme!"}
                                />
                            </Card>
                        </Col>
                    </Row>
                )}

                {(dataSource?.length === 0 && isEmptyObject(initialFilters) === false) && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <Card>
                                <ErrorCard
                                    message={"Nuk ka votues për këtë kërkim!"}
                                />
                            </Card>
                        </Col>
                    </Row>
                )}

                {(dataSource?.length > 0 && isEmptyObject(initialFilters) === false) && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <Card bodyStyle={{ padding: "0px" }} style={{ borderRadius: "0" }}>
                                <Row gutter={24} className="p-2">
                                    <Col xl={2} lg={2} md={2} sm={2} xs={2} className="font-weight-bold text-center">
                                        #
                                    </Col>
                                    <Col xl={13} lg={13} md={13} sm={13} xs={13} className="font-weight-bold">
                                        Votuesi
                                    </Col>
                                    <Col xl={5} lg={5} md={5} sm={5} xs={5} className="font-weight-bold text-center">
                                        Nr. liste
                                    </Col>
                                    <Col xl={4} lg={4} md={4} sm={4} xs={4} className="font-weight-bold text-center">
                                        Votoi
                                    </Col>
                                </Row>

                                {dataSource.map((elm, index) => (
                                    <Row gutter={24} key={index}>
                                        <Col span={24}>
                                            <Row gutter={24}>
                                                <Col span={24}>
                                                    <Divider className="w-100 mt-0 mb-0" />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} className="p-2">
                                                <Col xl={2} lg={2} md={2} sm={2} xs={2} className="font-weight-bold text-center">
                                                    {index + 1}.
                                                </Col>
                                                <Col xl={13} lg={13} md={13} sm={13} xs={13}>
                                                    {elm?.name + " " + elm?.father_name + " " + elm?.surname}
                                                </Col>
                                                <Col xl={5} lg={5} md={5} sm={5} xs={5} className="text-center">
                                                    {elm?.list_number}
                                                </Col>
                                                <Col xl={4} lg={4} md={4} sm={4} xs={4} className="text-center">

                                                    {elm?.voted === true && (
                                                        <Tag className="m-0" color="green">PO</Tag>
                                                    )}

                                                    {elm?.voted === false && (
                                                        <Tag className="m-0" color="magenta">JO</Tag>
                                                    )}

                                                </Col>
                                            </Row>

                                            {elm?.voted === true && (
                                                <Row gutter={24} className="p-2">
                                                    <Col xl={20} lg={20} md={20} sm={20} xs={20} />
                                                    <Col xl={4} lg={4} md={4} sm={0} xs={0} className="text-center">
                                                        <Button
                                                            block
                                                            danger
                                                            onClick={() => showDeleteModal(elm)}
                                                            icon={<CloseOutlined />}
                                                        >
                                                            Fshi
                                                        </Button>
                                                    </Col>
                                                    <Col xl={0} lg={0} md={0} sm={4} xs={4} className="text-center">
                                                        <Button
                                                            block
                                                            danger
                                                            onClick={() => showDeleteModal(elm)}
                                                            icon={<CloseOutlined />}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}

                                            {elm?.voted === false && (
                                                <Row gutter={24} className="p-2">
                                                    <Col xl={20} lg={20} md={20} sm={20} xs={20} />
                                                    <Col xl={4} lg={4} md={4} sm={0} xs={0} className="text-center">
                                                        <Button
                                                            block
                                                            type="primary"
                                                            onClick={() => showConfirmModal(elm)}
                                                            icon={<PlusOutlined />}
                                                        >
                                                            Konfirmo
                                                        </Button>
                                                    </Col>
                                                    <Col xl={0} lg={0} md={0} sm={4} xs={4} className="text-center">
                                                        <Button
                                                            block
                                                            type="primary"
                                                            onClick={() => showConfirmModal(elm)}
                                                            icon={<PlusOutlined />}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}

                                        </Col>
                                    </Row>
                                ))}

                            </Card>
                        </Col>
                    </Row>
                )}

                <Row gutter={24}>
                    <Col span={24}>
                        <Modal
                            title={"Jeni duke konfirmuar votën e votuesit!"}
                            centered
                            visible={confirmModal}
                            closable={true}
                            onCancel={closeConfirmModal}
                            destroyOnClose={true}
                            footer={false}
                        >
                            <ConfirmVote
                                title={"Jeni të sigurtë që votuesi:"}
                                fullName={item?.name + " " + item?.surname}
                                loading={loading}
                                onOk={onConfirm}
                                onCancel={closeConfirmModal}
                            />
                        </Modal>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Modal
                            title={"Jeni duke fshirë votën e votuesit!"}
                            centered
                            visible={deleteModal}
                            closable={true}
                            onCancel={closeDeleteModal}
                            destroyOnClose={true}
                            footer={false}
                        >
                            <ConfirmDelete
                                title={"Jeni të sigurtë që doni të fshini votën për votuesin:"}
                                fullName={item?.name + " " + item?.surname}
                                loading={loading}
                                onOk={onDelete}
                                onCancel={closeDeleteModal}
                            />
                        </Modal>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default VotersList;